export default __webpack_public_path__ + "static/media/org-program-analytics-v2.50773e7a.png";